import { functions } from './firebase';

interface GeminiProxyResponse {
  text: string;
  functionCalls: Array<{
    name: string;
    args: Record<string, unknown>;
  }> | null;
}

export const geminiProxy = {
  async generateContent(
    contents: string,
    config?: Record<string, unknown>
  ): Promise<GeminiProxyResponse> {
    if (!functions) {
      throw new Error("Firebase Functions no está inicializado.");
    }

    const callable = functions.httpsCallable("geminiProxy");
    const result = await callable({ contents, config });
    return result.data as GeminiProxyResponse;
  },
};
